import React from 'react'
import '../skills/Skills.css'

export default function Skills() {
    return (<>
        <section className="content my-5">
            <h1 className='d-flex justify-content-center my-3 skill'>My Skills</h1>
        </section>
        <section className='content'>
        <div className="our-services">
            <div className="container ">
                <div className="row">
                    <div className="col-md-4 col-sm-6">
                        <div className="service-box ">
                            <div className="my-4 icon middles-content hvr-wobble-vertical">
                            <ion-icon name="logo-html5" style={{fontSize:"5rem", color:"white"}}></ion-icon>
                            </div>
                            <h3 className='middles-content ht'>HTML</h3>
                        </div>
                    </div> 
                    <div className="col-md-4 col-sm-6">
                        <div className="service-box">
                            <div className="my-4 icon middles-content hvr-wobble-vertical">
                            <ion-icon name="logo-css3" style={{fontSize:"5rem", color:"white"}}></ion-icon>
                            </div>
                                <h3 className='middles-content' >CSS</h3>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                        <div className="service-box">
                            <div className="my-4 icon middles-content hvr-wobble-vertical">
                            <ion-icon name="logo-javascript" style={{fontSize:"5rem", color:"white", }}></ion-icon>
                            </div>
                            <h3 className='middles-content'>JavaScript</h3>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                        <div className="service-box">
                            <div className=" my-4 icon middles-content hvr-wobble-vertical">
                                <div className='rotate'>
                            <ion-icon name="logo-react" style={{fontSize:"5rem", color:"white"}}></ion-icon>
                            </div>
                            </div>
                                <h3 className='middles-content'>React</h3>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                        <div className="service-box">
                            <div className="my-4 icon middles-content hvr-wobble-vertical">
                            <ion-icon name="logo-python" style={{fontSize:"5rem", color:"white"}}></ion-icon>
                            </div>
                                <h3 className='middles-content'>Python</h3>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                        <div className="service-box">
                            <div className="my-4 icon middles-content hvr-wobble-vertical">
                            <ion-icon name="image-outline" style={{fontSize:"5rem", color:"white"}}></ion-icon>
                            {/* <ion-icon name="logo-python" ></ion-icon> */}
                            </div>
                                <h3 className='middles-content'>Photoshop</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div></section>

    </>
    )
}
